import React from "react";
import {
  Box,
  Typography,
  ButtonBase,
  Grid2,
  useMediaQuery,
} from "@mui/material";
import {
  EducationalContentGroup,
  EducationalContentItem,
} from "../../../utility/interfaces/educationLibraryInterfaces";
import styles from "./MyLearnings.module.scss";
import { ArrowIcon } from "../../../components/icon-components/ArrowIcon";
import MyLearningCard from "../../../features/learning-card/MyLearningCard";
import { useTranslation } from "react-i18next";
import { getContentDuration } from "../../../utility/functions/common-functions";

interface MyLearningCategoryListProps {
  educationLibrary: EducationalContentGroup[];
  onCategoryClick: (categoryName: string) => void;
  setContentDetails: (content: EducationalContentItem) => void;
}

const MyLearningCategoryList: React.FC<MyLearningCategoryListProps> = ({
  educationLibrary,
  onCategoryClick,
  setContentDetails,
}) => {
  const isMobile = useMediaQuery("(max-width: 900px)");
  const { t } = useTranslation();
  const pendingStatuses = [
    t("inProgress"),
    t("pending"),
    t("taskPending"),
    t("notCompleted"),
    t("initiated"),
    t("notStarted"),
    "",
  ];

  return (
    <>
      {educationLibrary?.map((categoryBlock: EducationalContentGroup) => {
        const categoryCode = categoryBlock.activitySubCategory;
        const categoryName = categoryBlock.activitySubCategoryName;
        const contents = categoryBlock.contents.slice(0, 3);

        return (
          <Box key={categoryName} className={styles.categorySection}>
            <Box className={styles.categoryHeaderContainer}>
              <ButtonBase onClick={() => onCategoryClick(categoryCode)}>
                <Typography variant="h4" align="left">
                  {categoryName}
                  <ArrowIcon
                    width={20}
                    height={20}
                    style={{
                      transform: "rotate(180deg)",
                      marginLeft: 8,
                    }}
                  />
                </Typography>
              </ButtonBase>

              { !isMobile && (
                <ButtonBase onClick={() => onCategoryClick(categoryCode)}>
                  <Typography
                    variant="body1"
                    sx={{ textDecoration: "underline" }}
                  >
                    {t("viewAll")}{" "}
                  </Typography>
                </ButtonBase>
              )}
            </Box>

            <Grid2 container spacing={2}>
              {contents?.map((educationContent, index) => {
                const duration = getContentDuration(
                  educationContent.length,
                  educationContent.videoDuration
                );
                return (
                  <Grid2 key={index} size={{ xs: 12, sm: 12, md: 4 }}>
                    <Box className={styles.categoryContent}>
                      <MyLearningCard
                        key={index}
                        imageSrc={educationContent?.thumbnailURL}
                        imageAlt={educationContent?.title}
                        isNew={educationContent?.isNew}
                        duration={duration}
                        title={educationContent?.title}
                        width="100%"
                        height="250px"
                        contentType={educationContent?.educationalContentType}
                        activityPoints={educationContent?.rewardPoint}
                        changeHorizontalLayout={true}
                        showButton={false}
                        isCompleted={
                          !pendingStatuses.includes(
                            educationContent.activityCompletionStatus
                          )
                        }
                        hasAudioLink={
                          !!educationContent?.educationalContentAudioURL
                        }
                        activityCompletionStatus={
                          educationContent?.activityCompletionStatus
                        }
                        onButtonClick={() =>
                          setContentDetails(educationContent)
                        }
                      />
                    </Box>
                  </Grid2>
                );
              })}
            </Grid2>

            { isMobile && (
              <Box mt={2} textAlign="center">
                <ButtonBase onClick={() => onCategoryClick(categoryCode)}>
                  <Typography
                    variant="body1"
                    sx={{ textDecoration: "underline" }}
                  >
                    {t("viewAll")}
                  </Typography>
                </ButtonBase>
              </Box>
            )}
          </Box>
        );
      })}
    </>
  );
};

export default MyLearningCategoryList;

